import FeatureGates from '@atlaskit/feature-gate-js-client';
import { type Options, useCrossFlow } from '@atlassiansox/cross-flow-support';
import { useMessageInstanceEvent } from '@post-office/message-instance-event-frontend-client';
import { useMessageEvent } from '@post-office/message-lifecycle';
import type { ClickedElementAttributes } from '@post-office/shared-contracts/message-instance-event';
import { useCallback } from 'react';

export const useCrossflowMessageClicked = (
	crossflowOptions: Options,
	clickedElement: ClickedElementAttributes,
) => {
	const crossflow = useCrossFlow();
	const { messageClicked } = useMessageEvent();
	const { messageInstanceClicked } = useMessageInstanceEvent();

	const handleClick = useCallback((): void => {
		messageClicked().catch(() => {});
		messageInstanceClicked({
			messageEventType: 'clicked',
			clickedElement,
			action: {
				actionType: 'acknowledge',
			},
			additionalMetadataFromFrontend: {},
		}).catch(() => {});
		if (crossflow.isEnabled) {
			// GALILEO-5608 start
			if (
				crossflowOptions.sourceComponent === 'jira-your-work' &&
				crossflowOptions.sourceContext === 'tryItNow'
			) {
				crossflowOptions.journey = FeatureGates.getExperimentValue<'get-started' | 'decide'>(
					'twcg-893_open_cffe_in_your_work_touchpoint',
					'journey',
					'decide',
				);
			}
			// GALILEO-5608 end
			crossflow.api.open(crossflowOptions).catch(() => {});
		}
	}, [crossflow, crossflowOptions, clickedElement, messageClicked, messageInstanceClicked]);

	return { handleClick };
};
